import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import * as classnames from 'classnames';

import './styles.scss';

const Footer = ({isFixBottom}) => {
	const history = useHistory();
	const uid = useSelector((state) => state.firebase.auth.uid);
	const isLightFooter = useSelector((state) => state.ui.isLightFooter);

	const redirect = (event) => {
		event.preventDefault();
		uid && history.push(`/${event.target.dataset.name}`)
	};

	return (
		<footer 
			className={
				classnames('footer', {
					'footer--fix-bottom': isFixBottom,
					'footer--light': isLightFooter,
				})
			}
		>
			<div className="container">
				<div className="footer__copyright">
					<span>
						© 2020 Unity. All Rights Reserved.
					</span>
					<span>
						View our
					</span>
					<a 
						href="/" 
						onClick={redirect}
						data-name="terms-conditions"
					>
							Terms and Conditions
					</a>
					<span>and</span>
					<a 
						href="/"
						onClick={redirect}
						data-name="privacy"
					>
						Privacy Policy
					</a>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
